
/* - - TC Kimlik No Sorgulama için Custom Validator - - */
$.validator.addMethod(
"identityNo",
function (value) {
    if (value == null || value == undefined || value == "") {
        return true;
    }
    else {
        return TcNoDogrula(value);
    }
},
"<span>Geçerli bir kimlik no giriniz.</span>"
);


/* - - TC Kimlik No - Text değer için Fonksiyon Formatı - - */
function TcNoDogrula(kimlikNo) {

    var output = [];
    var kNo = kimlikNo.toString();

    for (i = 0; i < kNo.length; i++) {
        output.push(+kNo.charAt(i));
    }

    var single = output[0] + output[2] + output[4] + output[6] + output[8];
    var double = output[1] + output[3] + output[5] + output[7];

    var onuncu = (single * 7 - double) % 10;

    if (output[9] == onuncu) {
        var onbirinci = (single + double + onuncu) % 10;
        if (output[10] == onbirinci) {
            return true;
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
}

/* - - TC Kimlik No - Input için jQuery Plugin Formatı - - */
jQuery.fn.TcNoDogrula = function () {
    var output = [];
    var kNo = $(this).val().toString();

    for (i = 0; i < kNo.length; i++) {
        output.push(+kNo.charAt(i));
    }

    var single = output[0] + output[2] + output[4] + output[6] + output[8];
    var double = output[1] + output[3] + output[5] + output[7];

    var onuncu = (single * 7 - double) % 10;

    if (output[9] == onuncu) {
        var onbirinci = (single + double + onuncu) % 10;
        if (output[10] == onbirinci) {
            console.log('true');
            return true;
        }
        else {
            console.log('false');
            return false;
        }
    }
    else {
        console.log('false2');
        return false;
    }
};


function errorInputControl(inputName, spanName, chose) {
    if (chose == 1) {
        if ($(inputName).val() == "") {
            $(spanName).attr("class", "inputActive");
            $(inputName).validateControl();
            return false;
        } else {
            $(spanName).attr("class", "inputPassive");
            return true;
        }
    } else if (chose == 2) {

        if ($(inputName).text() == "Seçim Yapınız") {
            $(spanName).attr("class", "inputActive");
            return false;
        } else {
            $(spanName).attr("class", "inputPassive");
            return true;
        }
    }
}

/*
jQuery.fn.ForceNumericOnly = function () {
    return this.each(function () {
        $(this).keydown(function (e) {
            var key = e.charCode || e.keyCode || 0;
            // allow backspace, tab, delete, arrows, numbers and keypad numbers ONLY
            return (
                key == 8 ||
                key == 9 ||
                key == 46 ||
                (key >= 37 && key <= 40) ||
                (key >= 48 && key <= 57) ||
                (key >= 96 && key <= 105));
        });
    });
};

jQuery.fn.lengthLimit = function (length) {
    return this.each(function () {
        $(this).keydown(function (event) {
            var input = $(this).val();
            var numberOfWords = input.split(' ').length;
            if (numberOfWords == length && event.keyCode == 32) {
                return false;
            }
        });
    });
};



(function ($) {
    $.fn.redAlert = function () {
        if (this.alertIsRun != undefined && this.alertIsRun == true)
            return;
        this.alertIsRun = true;
        var borderColor = $(this).css('border-left-color');
        this
                .animate({ "border-color": "#FF0000" }, "fast")
                .animate({ "border-color": borderColor }, "fast")
                .animate({ "border-color": "#FF0000" }, "slow")
                .animate({ "border-color": borderColor }, "slow");
        this.alerIsRun = false;
    };
})(jQuery);

(function ($) {
    $.fn.validateControl = function () {
        if (this.val() == "" || this.val() == null) {
            this.redAlert();
            return false;
        }
        return true;
    }
})(jQuery);

(function ($) {
    $.fn.isChecked = function () {
        return (this.attr('checked') == "checked");
    }
})(jQuery);

(function ($) {
    $.fn.scrollItem = function (padding) {
        if (padding == null)
            padding = 0;
        var target = $(this);
        if (target.length) {
            var top = target.offset().top - padding;
            $('html,body').animate({ scrollTop: top }, 1000);
            return false;
        }

    };
})(jQuery);
*/